export default "__VITE_ASSET__478d792d__"